import React from "react";
import PdfListPage from "./PdfListPage";
import { useBul } from "./BulLayout";

export default function ImportantLinks() {
  const data = useBul();
  return (
    <PdfListPage
      eyebrow="Resources"
      title="Important Links"
      accent="teal"
      items={data.links || []}
      testid="bul-links"
      emptyMsg="No important links have been published yet."
    />
  );
}
